import { Box, Stack, alpha } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Iconify from '../../iconify'

const WalletStar = ({width}) => {

    let _width  = width ?? 32

    return ( 
        <Box sx={{
            background: alpha("#FBF6A7",1),
            borderRadius:'50%',
            position:'relative',
            height:_width, 
            width: _width
        }}>
            <Stack alignItems='center' justifyContent='center' sx={{height:'100%'}}>
                <Iconify icon="ic:round-star"  color="#FFCC4D" width={_width*0.75}/>
            </Stack>
            
        </Box>
     );
}
 
export default WalletStar;